import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-registrar-admin-maintenance-grade-change-code-map',
    templateUrl: './grade-change-code-map.component.html',
    styleUrls: ['./grade-change-code-map.component.scss']
})
export class GradeChangeCodeMapComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {
        //
    }
}
